module.exports = __webpack_public_path__ + "static/media/full_6.747a45d4.jpg";